export * from './job-detail.component';
export * from './job-detail.service';



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/job/job-detail/index.ts